var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-empty',{staticClass:"empty",class:{'is-xl': _vm.isExtraLarge},attrs:{"image":_vm.simpleImage}},[_c('span',{staticClass:"empty__text",attrs:{"slot":"description"},slot:"description"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }